import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  .selected-especialist {
    align-items: center;
    display: flex;
  }
  .username {
    color: #000;
    font-family: 'Inter';
    font-size: 12px;
    font-weight: 500;
    line-height: normal;
  }
  .profile-pic {
    width: 24px;
    height: 24px;
    margin-right: 4px;
    border-radius: 5px;
  }
  .remove-btn {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: auto;
  }
`
